exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".order_list{border-top:1px solid #000;width:100%}.card{font-family:Taviraj}.btn-payment{color:#fff;font-size:2.2vw;height:130px;width:100%;-moz-text-align-last:center;text-align-last:center}", "", {"version":3,"sources":["/Users/chakritkanpromkad/Desktop/Sourcetree/Mariminterfood/pos_ui-Develop/src/views/order.vue"],"names":[],"mappings":"AACA,YACE,0BAA2B,AAC3B,UAAY,CACb,AACD,MACE,mBAAuB,CACxB,AACD,aACE,WAAY,AACZ,gBAAiB,AACjB,aAAc,AACd,WAAY,AACZ,4BAA6B,AACxB,sBAAwB,CAC9B","file":"order.vue","sourcesContent":["\n.order_list {\n  border-top: 1px solid #000;\n  width: 100%;\n}\n.card {\n  font-family: \"Taviraj\";\n}\n.btn-payment {\n  color: #fff;\n  font-size: 2.2vw;\n  height: 130px;\n  width: 100%;\n  -moz-text-align-last: center;\n       text-align-last: center;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4aa03e1e","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/order.vue
// module id = 1295
// module chunks = 3